"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ReportPreviewItem = function (_a) {
  var uniqueKey = _a.uniqueKey,
      src = _a.src,
      name = _a.name,
      supportHover = _a.supportHover;

  var _b = (0, react_1.useState)(!supportHover),
      isHovered = _b[0],
      setIsHovered = _b[1];

  var key = uniqueKey;

  var handleMouseDown = function () {
    if (supportHover) {
      setIsHovered(!isHovered);
    }
  };

  return react_1.default.createElement("div", {
    key: key,
    className: "report-item",
    role: "button",
    tabIndex: -1,
    onMouseDown: handleMouseDown
  }, react_1.default.createElement("img", {
    className: isHovered ? 'report-image-expanded' : 'report-image',
    src: src,
    alt: name
  }));
};

exports.default = ReportPreviewItem;